import { useFormContext } from 'react-hook-form';
import { Box, Grid } from '@mui/material';
import { DynamicFormConfig } from './dynamic-form.types';
import { DynamicField } from './utils/dynamic-field/dynamic-field';

type DynamicDocumentFormProps = {
  config: DynamicFormConfig;
};

export const DynamicForm = ({ config }: DynamicDocumentFormProps) => {
  const formMethods = useFormContext<Record<string, unknown>>();

  return (
    <Box display="flex" flex={1} flexDirection="column">
      <Grid container spacing={2}>
        {config.items.map((field) => (
          <Grid item xs={6} key={field.key}>
            <DynamicField field={field} control={formMethods.control} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
